import { Component, TemplateRef } from "@angular/core";
import { ToastService } from "src/app/core/services/toast.service";
import { CommonModule } from "@angular/common";
import { NgbToastModule } from "@ng-bootstrap/ng-bootstrap";
import { MatIconModule } from "@angular/material/icon";

@Component({
  selector: "app-success-toast",
  templateUrl: "./success-toast.component.html",
  styleUrls: ["./success-toast.component.scss"],
  host: { "[class.ngb-toasts]": "true" },
  imports: [CommonModule, NgbToastModule, MatIconModule],
})
export class SuccessToastComponent {
  constructor(public toastService: ToastService) {}

  isTemplate(toast) {
    return toast.textOrTpl instanceof TemplateRef;
  }
}
